import { alterarSituacaoDistribuicao } from "@/modules/financeiro-configuracoes";
import { useChaveIdempotencia } from "@/shared/hooks";
import {
  EFEITOS_INATIVAR,
  INATIVAR_TEXTOS,
  SITUACAO_INATIVA,
} from "./situacao-distribuicao-dialog.constants";
import { resumoDaDistribuicao } from "./situacao-distribuicao-dialog.utils";
import type {
  SituacaoDistribuicaoDialogProps,
  SituacaoDistribuicaoDialogViewModel,
} from "./types-situacao-distribuicao-dialog";

export function useSituacaoDistribuicaoDialog({
  distribuicao,
  onClose,
  onConcluido,
}: SituacaoDistribuicaoDialogProps): SituacaoDistribuicaoDialogViewModel {
  const { comChave } = useChaveIdempotencia();
  const textos = INATIVAR_TEXTOS;

  return {
    acao: "inativar",
    titulo: textos.titulo,
    subtitulo: textos.subtitulo,
    confirmLabel: textos.titulo,
    tituloEfeitos: textos.tituloEfeitos,
    oQueAcontece: EFEITOS_INATIVAR,
    identificacao: {
      intro: textos.intro,
      nome: distribuicao.nome,
      resumo: resumoDaDistribuicao(distribuicao),
    },
    onConfirmar: async () => {
      await comChave({ id: distribuicao.id, situacao: SITUACAO_INATIVA }, (idempotencyKey) =>
        alterarSituacaoDistribuicao(distribuicao.id, SITUACAO_INATIVA, { idempotencyKey }),
      );
      onConcluido();
    },
    onCancelar: onClose,
  };
}
